module.exports = __webpack_public_path__ + "img/logo-white.f739ab5f.svg";